import imageCompression from "browser-image-compression";

export const convertToWebP = async (file) => {
    try {
        // Try WebP first (works well on Chrome)
        const webpResult = await imageCompression(file, {
            maxSizeMB: 5,
            maxWidthOrHeight: 1920,
            useWebWorker: true,
            fileType: "image/webp",
            initialQuality: 0.85,
        });

        if (webpResult.size < file.size) {
            return new File(
                [webpResult],
                file.name.replace(/\.\w+$/, ".webp"),
                { type: "image/webp" }
            );
        }

        // WebP didn't compress (Safari) — fall back to JPEG
        const jpegResult = await imageCompression(file, {
            maxSizeMB: 5,
            maxWidthOrHeight: 1920,
            useWebWorker: true,
            fileType: "image/jpeg",
            initialQuality: 0.85,
        });

        if (jpegResult.size < file.size) {
            return new File(
                [jpegResult],
                file.name.replace(/\.\w+$/, ".jpeg"),
                { type: "image/jpeg" }
            );
        }

        return file;
    } catch {
        return file;
    }
};